import { gql } from '@apollo/client';

const getShippingQuery = () => {
  const query = `
  query Shipping($itemId: String!, $zipCode: String, $storeId: String, $quantity: Int!, $price: Float!) {
    shipping(itemId: $itemId, zipCode: $zipCode, storeId: $storeId, quantity: $quantity, price: $price) {
      excludedShipStates
      zipCode
      state
      services {
        type
        freeDeliveryThreshold
        deliveryTimeline
        deliveryDates {
          startDate
          endDate
          timeOfArrival
        }
        dynamicEta {
          hours
          minutes
        }
        mode {
          code
          desc
          longDesc
          group
        }
        totalCharge
        __typename
      }
      __typename
    }
  }
  `;

  return gql(query);
};

export default getShippingQuery;
